import { useSalesLocale } from '../../locale';


import React from 'react';
import { Segmented } from 'antd';

export type NotificationFilterTab = 'all' | 'unread' | 'tasks' | 'leads' | 'whatsapp' | 'requests';

interface NotificationFiltersProps {
  value: NotificationFilterTab;
  onChange: (next: NotificationFilterTab) => void;
}

export const NotificationFilters: React.FC<NotificationFiltersProps> = ({ value, onChange }) => {
  const { labels: salesLabels } = useSalesLocale();



  return (
    <div className="sales-notification-filters"><Segmented
      block
      value={value}
      onChange={(next) => onChange(next as NotificationFilterTab)}
      options={salesLabels([
        { label: 'All', value: 'all' },
        { label: 'Unread', value: 'unread' },
        { label: 'Tasks', value: 'tasks' },
        { label: 'Leads', value: 'leads' },
        { label: 'WhatsApp', value: 'whatsapp' },
        { label: 'Requests', value: 'requests' },
      ])}
    /></div>
  );
};
